import * as SecurityApi from '@/api/security'

const state = {
  phishingRules: null,
  phishingRulesEtag: null,
  phishingRulesLoaded: false
}

const defaultRules = {
  high_keywords: [],
  medium_keywords: [],
  high_single_trigger_keywords: [],
  intent_keywords: [],
  intent_required_keywords: []
}

const getters = {
  phishingRules(state) {
    return state.phishingRules
  },
  phishingRulesLoaded(state) {
    return state.phishingRulesLoaded
  }
}

const actions = {
  async fetchPhishingRulesIfNeeded({ state, commit }, force = false) {
    if (!force && state.phishingRulesLoaded) {
      return state.phishingRules
    }

    const response = await SecurityApi.getPhishingRules(state.phishingRulesEtag)
    const responseEtag = response?.headers?.etag || state.phishingRulesEtag

    if (response.status === 304) {
      commit('SET_PHISHING_RULES_ETAG', responseEtag)
      commit('SET_PHISHING_RULES_LOADED', true)
      return state.phishingRules
    }

    commit('SET_PHISHING_RULES', response?.data?.data || defaultRules)
    commit('SET_PHISHING_RULES_ETAG', responseEtag)
    commit('SET_PHISHING_RULES_LOADED', true)

    return state.phishingRules
  }
}

const mutations = {
  SET_PHISHING_RULES(state, payload) {
    state.phishingRules = {
      ...defaultRules,
      ...(payload || {})
    }
  },
  SET_PHISHING_RULES_ETAG(state, etag) {
    state.phishingRulesEtag = etag
  },
  SET_PHISHING_RULES_LOADED(state, loaded) {
    state.phishingRulesLoaded = loaded
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
